import { css } from "styled-components";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
import { StyledButtonGroup } from "../../components/ButtonGroup/ButtonGroup";
import { StyledLabel } from "../../components/Label/Label";
import { StyledFormHelp } from "../../components/FormHelp/FormHelp";
import { StyledLabeledControl } from "../../components/LabeledControl/LabeledControl";
/** @class FormFieldMixin */

/** @method */

export var FormFieldMixin = function FormFieldMixin(props) {
  return css(["> ", "{display:block;padding-bottom:", ";}> ", "{margin-top:", ";}> ", "{margin-left:", ";}> ", "{margin-top:", ";}border:0;padding:0;margin:0;", ""], StyledLabel, spaceMixin(0.5)(props), StyledFormHelp, spaceMixin(0.5)(props), StyledLabeledControl, spaceMixin("xs")(props), StyledButtonGroup, spaceMixin("xs")(props), spacingMixin(props));
};